// Competitive Pricing Data - McKesson vs APS
// Source: APS Brochure - CORRECTED TABLE

export const competitivePricing = {
  'TCV-13': {
    mckessonPrice: 39.18,
    apsPrice: 35.40,
    savingsPercent: 10,
    qtyPerCarton: 215
  },
  'TCV-16': {
    mckessonPrice: 33.00,
    apsPrice: 32.30,
    savingsPercent: 2,
    qtyPerCarton: 175
  },
  'CR-06': {
    mckessonPrice: 69.00,
    apsPrice: 55.86,
    savingsPercent: 19,
    qtyPerCarton: 600
  },
  'CR-08': {
    mckessonPrice: 46.00,
    apsPrice: 40.72,
    savingsPercent: 11,
    qtyPerCarton: 410
  },
  'CR-13': {
    mckessonPrice: 54.00,
    apsPrice: 45.80,
    savingsPercent: 15,
    qtyPerCarton: 310
  },
  'CR-20': {
    mckessonPrice: 61.11,
    apsPrice: 55.11,
    savingsPercent: 10,
    qtyPerCarton: 400
  },
  'RCV-08': {
    mckessonPrice: 53.00,
    apsPrice: 45.86,
    savingsPercent: 13,
    qtyPerCarton: 410
  },
  'RCV-13': {
    mckessonPrice: 48.00,
    apsPrice: 43.31,
    savingsPercent: 10,
    qtyPerCarton: 275
  },
  'RCV-20': {
    mckessonPrice: 51.00,
    apsPrice: 46.90,
    savingsPercent: 8,
    qtyPerCarton: 270
  },
  'OJ-100': {
    mckessonPrice: 42.48,
    apsPrice: 34.11,
    savingsPercent: 20,
    qtyPerCarton: 48
  },
  'OJ-400': {
    mckessonPrice: 52.80,
    apsPrice: 45.25,
    savingsPercent: 14,
    qtyPerCarton: 48
  }
};

// Helper function to get pricing info
export const getPricingInfo = (productId) => {
  return competitivePricing[productId] || null;
};

// Helper function to calculate savings display
export const getSavingsDisplay = (productId) => {
  const pricing = getPricingInfo(productId);
  if (!pricing) return null;
  
  const dollarSavings = pricing.mckessonPrice - pricing.apsPrice;
  
  // If savings > $5, show dollars, otherwise show percentage
  if (dollarSavings > 5) {
    return {
      type: 'dollar',
      value: dollarSavings.toFixed(2),
      display: `Save $${dollarSavings.toFixed(2)} per box`
    };
  } else {
    return {
      type: 'percent',
      value: pricing.savingsPercent,
      display: `Save ${pricing.savingsPercent}%`
    };
  }
};
